import Swal from "sweetalert2/dist/sweetalert2";
import { i18n } from "@/i18n";

class NotificationManager {
  constructor() {}

  showAlert(
    title,
    subTitle = "",
    closeButton = false,
    cancelButton = false,
    confirmButtonText = null,
    cancelButtonText = null,
    timer,
    confirmButton = true,
  ) {
    const swal = new Swal({
      title: title,
      text: subTitle,
      timer: timer,
      padding: "2em",
      showCloseButton: closeButton,
      showDenyButton: cancelButton,
      showConfirmButton: confirmButton,
      denyButtonText: cancelButtonText
        ? cancelButtonText
        : i18n.global.t("cancel"),
      confirmButtonText: confirmButtonText
        ? confirmButtonText
        : i18n.global.t("confirm"),
      confirmButtonColor: "#002856",
      denyButtonColor: "#e30613",
      iconHtml:
        "<div class='aixam'><img src='/assets/images/images/logo.png'/><div class='aixam__tv'>TV</div></div>",
    });

    const container = document.querySelector(".swal2-container");
    container.addEventListener("click", function (e) {
      e.stopPropagation();
    });

    return swal;
  }
}

export const notificationManager = new NotificationManager();
